// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;That your way may be known upon earth,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;your saving power among all nations.<br> </p> </div></div>";
// Exports
module.exports = code;